import { divCard } from '../../cls';
import './background.less';

export var backgroundNS = divCard('background');
export var background = backgroundNS();
export var layer = backgroundNS('layer');